import FastMarquee from "react-fast-marquee";
import { Snowflake } from "lucide-react";

const ITEMS = [
  "Same-day metro",
  "-18°C frozen",
  "2-8°C pharma",
  "0-4°C chilled",
  "GPS tracked",
  "HACCP aligned",
  "Dock to door",
];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-white/10 bg-surface/40 py-6 overflow-hidden">
    <FastMarquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-8 mx-8">
          <span className="font-display text-2xl lg:text-4xl font-medium uppercase tracking-tight text-snow/80 whitespace-nowrap">
            {item}
          </span>
          <Snowflake className="w-5 h-5 text-frost shrink-0" strokeWidth={1.5} />
        </span>
      ))}
    </FastMarquee>
  </div>
);

export default Marquee;
